import Typography from 'components/Typography/Typography';
import styles from '../CustomerTimeline.module.scss';
import Avatar from 'components/Avatar';
import {format, parseISO} from 'date-fns';
import {TimelineNote as TimelineItem} from 'types/timeline-note';

interface TimelineNoteProps {
  note: TimelineItem;
}

function TimelineNote({note}: TimelineNoteProps) {
  const {text, author, created_at, avatar} = note;
  return (
    <div className={styles.note}>
      <div className={styles.row_name}>
        <Typography variant="p">{text}</Typography>
      </div>
      <div className={styles.bottom}>
        <div className={styles.author}>
          <Avatar name={author} file={avatar} size="sm" />
          <span className={styles.author__name}>{author}</span>
        </div>
        <span className={styles.datetime}>
          {format(parseISO(created_at), 'MMMM d Y, h:mm aa')}
        </span>
      </div>
    </div>
  );
}

export default TimelineNote;

// import {format, parseISO} from 'date-fns';

// import Typography from 'components/Typography';

// import {Note as NoteType, Transaction} from 'types';

// import styles from './Note.module.scss';
// import Avatar from 'components/Avatar';
// import {useHistory} from 'react-router-dom';

// interface Props {
//   route_id?: number | null;
//   isCompleted: boolean;
//   isRouteClickable?: boolean;
//   note: NoteType;
//   transactions: Transaction[];
// }

// function Note({
//   isRouteClickable,
//   route_id,
//   isCompleted,
//   note,
//   transactions,
// }: Props) {
//   const history = useHistory();
//   const {text, author, created_at, avatar, is_visible_to_drivers, note_type} =
//     note;

//   const payment_url = 'magicdispatch.com/payment?';
//   const transactionId = text.includes('Transaction ID')
//     ? text.split('Transaction ID: ')[1]
//     : null;
//   const lasttext = text.includes('Transaction ID')
//     ? text.slice(0, text.lastIndexOf('Transaction ID: ') + 15)
//     : text.includes(payment_url)
//     ? text.slice(0, text.indexOf('payment:') + 9)
//     : text;

//   const transaction = transactions.find(
//     (transaction) => transaction.transaction_id === transactionId
//   );

//   const handleRouteClick = () => {
//     if (!route_id) return;
//     history.push(`/history/routes/${route_id}`);
//   };
//   return (
//     <div className={styles.root}>
//       {is_visible_to_drivers && (
//         <p className={styles.visible}>Visible to Workers</p>
//       )}
//       <div className={styles.row_name}>
//         <Typography variant="p">
//           {lasttext}
//           {text.includes(payment_url) && (
//             <a
//               rel="noreferrer"
//               href={`${text.split('payment:')[1]}`}
//               target="_blank"
//               className={styles.payment_url}
//             >
//               {text.split('payment: ')[1]}
//             </a>
//           )}
//         </Typography>
//         {text.includes('Transaction ID') && (
//           <Typography
//             onClick={() =>
//               history.push(`/transactions/${transactionId}`, {
//                 isRouteHistory: true,
//               })
//             }
//             className={styles.transaction_id}
//             variant="p"
//           >
//             {transaction?.sequential_order_number}
//           </Typography>
//         )}
//         {isCompleted && note_type === 'notes' && (
//           <Typography
//             onClick={handleRouteClick}
//             className={styles.route_id}
//             variant="p"
//           >
//             See route
//           </Typography>
//         )}
//         {!isCompleted &&
//           isRouteClickable &&
//           !!route_id &&
//           note_type === 'notes' && (
//             <Typography
//               onClick={handleRouteClick}
//               className={styles.route_id}
//               variant="p"
//             >
//               See route
//             </Typography>
//           )}
//       </div>
//       <div className={styles.bottom}>
//         <div className={styles.author}>
//           <Avatar name={author} file={avatar} size="sm" />
//           <span className={styles.author__name}>{author}</span>
//         </div>
//         <span className={styles.datetime}>
//           {format(parseISO(created_at), 'MMMM d Y, h:mm aa')}
//         </span>
//       </div>
//     </div>
//   );
// }

// export default Note;
